const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/+$/, "");

// Keep browser requests same-origin so the HttpOnly session cookie is sent.
// CRA proxies /Api during development; Nginx proxies it in production.
export const baseURL = configuredBaseUrl || "/Api";
